import MyFirstGameScreen from '@/screens/my-first-game/MyFirstGameScreen'

export default function () {
  return <MyFirstGameScreen />
}
